import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

const MATCH2_DAILY_CHALLENGE = 'match2 Daily Challenge';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_DAILY_CHALLENGE] = [
    {
      text: 'Reset Daily Challenge',
      color: 'secondary',
      cheat: async () => {
        StateObserver.invoke.cheat_match2Reset2DailyChallenge();
      },
    },
    {
      text: 'Progress Daily Challenge',
      color: 'secondary',
      cheat: async () => {
        StateObserver.invoke.cheat_match2ProgressDailyChallenge({ ratio: 0.5 });
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_DAILY_CHALLENGE:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2DailyChallengeCheats = {
  list,
  ui,
};
